import template from './sw-cms-el-config-acris-faq-single.html.twig';

const { Component, Mixin } = Shopware;

const { EntityCollection, Criteria } = Shopware.Data;

Component.register('sw-cms-el-config-acris-faq-single', {
    template,

    mixins: [
        Mixin.getByName('cms-element')
    ],

    inject: ['repositoryFactory'],

    computed: {
        // faqGroupCriteria() {
        //     const criteria = new Criteria();
        //     criteria.addAssociation('faqs');
        //     return criteria;
        // },

        faq() {
            return this.repositoryFactory.create('acris_faq');
        }
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.initElementConfig('acris-faq-single');

            if (this.element.config.faqs.value.length === 0) {
                this.element.config.faqs.value = this.createFaqCollection();
            } else {
                const emptyFaqGroup = this.createFaqCollection();
                this.element.config.faqs.value.forEach((value) => {
                    emptyFaqGroup.add(value);
                });

                this.element.config.faqs.value = emptyFaqGroup;
            }
        },

        createFaqCollection() {
            return new EntityCollection('/acris_faq', 'acris_faq', Shopware.Context.api, new Criteria());
        }
    }

});
